import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthService} from 'app/core/services/auth.service';
import {DemoService} from 'app/core/services/demo.service';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {NavigateAfterLoginService} from 'app/features/sign-in/services/navigate-after-login.service';

@Injectable({
    providedIn: 'root',
})
export class AutoDemoSignInGuard {
    constructor(
        private auth: AuthService,
        private demo: DemoService,
        private afterLoginService: NavigateAfterLoginService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        if (!this.demo.isDemoHost) {
            return true;
        }

        if (this.auth.isLoggedIn()) {
            return true;
        }

        return this.auth.demoSignIn().pipe(
            tap(() => this.afterLoginService.navigate()),
            map(() => false)
        );
    }
}
